import { createStore } from "vuex";
import axios from "axios";

const store = createStore({
  state: {
    schemeData: null, 
    loading: false,   
    error: null,     
  },
  mutations: {
    SET_SCHEME_DATA(state, payload) {
      state.schemeData = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_ERROR(state, payload) {
      state.error = payload;
    },
  },

  actions: {
  async fetchSchemeData({ commit }, schemeCodeFromParam = null) {
  commit("SET_LOADING", true);
  commit("SET_ERROR", null);

  const schemeCode =
    schemeCodeFromParam || window.location.pathname.split("/").filter(Boolean).pop();

  if (!schemeCode) {
    console.warn("No scheme code provided. Loading fallback demo.json...");
    try {
      const fallbackResponse = await axios.get("/data/demo.json");
      commit("SET_SCHEME_DATA", fallbackResponse.data);
    } catch (error) {
      commit("SET_ERROR", "Failed to load fallback data.");
    } finally {
      commit("SET_LOADING", false);
    }
    return;
  }

  try {
    const startRequest = performance.now();
    const response = await axios.get(
      `${process.env.VUE_APP_BASE_URL}/wp-admin/admin-ajax.php?action=schemeDetails_api&schemeCode=${schemeCode}`
    );
    const endResponse = performance.now();
    const requestTime = endResponse - startRequest;
    console.log(`API start time: ${startRequest} ms`);
    console.log(`API request time: ${endResponse} ms`);
    console.log(`API request time: ${requestTime} ms`);


    commit("SET_SCHEME_DATA", response.data);
  } catch (error) {
    commit("SET_ERROR", "Failed to fetch scheme data from API.");
    try {
      const fallbackResponse = await axios.get("/data/demo.json");
      commit("SET_SCHEME_DATA", fallbackResponse.data);
      console.log("Loaded fallback scheme data from demo.json.");
    } catch (fallbackError) {
      commit("SET_ERROR", "Unable to load data from both API and fallback.");
    }
  } finally {
    commit("SET_LOADING", false);
  }
}
  },
  
  getters: {
    schemeData: (state) => state.schemeData,
    loading: (state) => state.loading,
    error: (state) => state.error,
  },
});

export default store;
